import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { OrdersComponent } from './orders.component';
import { OrderItemsComponent } from './order-items/order-items.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {path:'', redirectTo:'list',pathMatch:'full'},
      {path:'list', component: OrdersComponent},
      {path:'detail', component: OrderItemsComponent},
    ]),
  ],
  exports:[RouterModule]
})
export class OrdersRoutingModule { }
